import { TopViewSp } from 'components/top-sp'
import { TopViewPc } from 'components/top'
import { Fragment } from 'react'
import { Resizer } from 'components/base/Resizer'

export default function TopPage() {
  return (
    <Fragment>
      <div style={{ display: 'none' }}>
        <img src='/images/assets/bot_top.webp' alt='bot' />
      </div>
      <div className='sp-version'>
        <TopViewSp />
      </div>
      <div className='pc-version'>
        <TopViewPc />
      </div>
      <Resizer />
    </Fragment>
  )
}
